/* eslint-disable import/prefer-default-export */
import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'recaudacion/estado-de-cartera-pae';

export const getEstadosDeCarteraPae = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};
